<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-configuration-alert-overall-kpis" v-loading="loading">
    <div class="div-title-section"> 
      <div class="div-title">
        Overall Bot Metric Alerts
        <div class="question-mark">
          <wy-page-section-tooltip :tooltipsContent="tooltipConversationTopicsAlerts" />
        </div>
      </div>
      <div class="update-btns">
        <button :class="(!hasDataChanged||hasError?'update-save-btn disabled':'update-save-btn')"  :disabled="!hasDataChanged||hasError" @click="updateKpi">Update</button>
      </div>
    </div>
    <div class="div-info">
      Configure alerts for the listed metrics to stay updated on data changes and to identify anomalies. Receive daily notifications whenever a metric alert condition, using overall bot data from the past day, is met.
    </div>
    <span class="clear-all-alerts" :class="{'disabled':hasNoRules}" @click="handleClearAllAlerts(hasNoRules)">Clear all alerts</span>
    <div class="content-section"> 
      <div v-for="(kpi, kpiIndex) in localKPIData" :key="kpiIndex" :class="{'show-top': kpiIndex==controller.topicKpis.length}">
        <el-collapse v-if="controller.overallKpis.includes(kpi.metric)" v-model="activeNames" @change="handleChange(kpi.metric)" class="kpi-collapse">
          <el-collapse-item :name="kpi.metric">
            <template slot="title">
              <div class="kpi-collapse-header">
                {{getKPILabel(kpi.metric)}}
                <!-- <div class="question-mark">
                  <wy-page-section-tooltip :tooltipsContent="tooltipCollapseKPI" />
                </div> -->
                <div v-if="activeNames.includes(kpi.metric)" class="ignore-wrap-div" @mouseover="mouseover($event, `${tooltipCollapseKPI}`)" @mouseout="mouseout"></div>
                <div v-else class="ignore-wrap-div" @mouseover="mouseover($event, `${tooltipExpendKPI}`)" @mouseout="mouseout"></div>
                <el-dropdown v-if="activeNames.includes(kpi.metric)" trigger="click"  @command="handleCommand" class="kpi-dropdown">
                  <!-- <span class="el-dropdown-link">
                    Dropdown List<i class="el-icon-arrow-down el-icon--right"></i>
                  </span> -->
                  <!-- <button class="horizontal-dots" @click="handleDropdownMenu"></button> -->
                  <button :disabled="!hasAlert(kpi)" class="horizontal-dots" :class="{'disabled': !hasAlert(kpi)}" @click="handleDropdownMenu"></button>
                  <el-dropdown-menu slot="dropdown" class="kpi-dropdown-menu">
                    <el-dropdown-item :command="{name:'delete',kpi:kpi}"><span>Delete</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div v-else-if="hasAlert(kpi)" class="kpi-status"><span class="has-alerts"></span>Alerts setup</div>
                <div v-else class="kpi-status"><span class="has-no-alerts"></span>No alerts setup</div>
              </div>
            </template>
            <div class="kpi-content">
              <!-- <wy-kpi-date-range :lastDateNumber="rule.lastDateNumber" :controller="module" :topic="topic" :rule="rule" :ruleIndex="ruleIndex"></wy-kpi-date-range> -->
              <div v-if="kpi.items[0].rules.length>0" class="rules">
                <div v-for="(rule, ruleIndex) in kpi.items[0].rules" :key="ruleIndex">
                  <span v-if="ruleIndex>0" class="rule-or-display">or</span>
                  <wy-kpi-date-range :ref="kpi.metric+'rule'+ruleIndex"  :lastDateNumber="rule.lastDateNumber" :controller="module" :topic="kpi.items[0]" :rule="rule" :ruleIndex="ruleIndex"></wy-kpi-date-range>
                  <div class="ignore-wrap-div" @mouseover="mouseover($event, `${tooltipDeleteRuleset}`)" @mouseout="mouseout">  
                    <span class="remove-item el-icon-close" @click="handleRemoveRule(kpi.items[0], ruleIndex)"></span>
                  </div>
                </div>
              </div>
              <div v-if="showAddNewRule(kpi.items[0])" class="kpi-add-new-rule">
                <div v-if="kpi.items[0].rules.length==0" class="ignore-wrap-div" @mouseover="mouseover($event, `${tooltipAddNewRule}`, null, 25)" @mouseout="mouseout">
                  <span class="span-plus">+</span>
                  <el-button class="new-rule-button" size="small" @click="handleAddNewRule(kpi.items[0])"> Add a new rule </el-button>
                </div>
                <div v-else class="ignore-wrap-div" @mouseover="mouseover($event, `${tooltipsAddAnotherRule}`, null, 25)" @mouseout="mouseout">
                  <span class="span-plus">+</span>
                  <el-button class="new-rule-button" size="small" @click="handleAddNewRule(kpi.items[0])"> Add another rule </el-button>
                </div>
              </div>
              
              
              <!-- <wy-kpi-contact-reasons v-if="showAddTopicBtn(kpi)" :controller="module" :kpi="kpi" :kpiIndex="kpiIndex" :contactReasonsList="contactReasonsList"> </wy-kpi-contact-reasons> -->
              <!-- <div class="topics-list-section">
                <div class="topics-list">
                  <el-collapse v-model="localKPIDataWithExtraProps[kpiIndex].expendedTopics" v-for="(topic, topicIndex) in kpi.items" :key="topicIndex" class="topic-section" @change="handleChange">
                    <el-collapse-item v-if="topic.type=='overall'" :name="topicIndex">
                      <template slot="title">
                        <span class="topic-index">{{topicIndex}}</span> 
                        <span class="topic-name">{{topic.topicDisplayName}}</span>
                        <div v-if="localKPIDataWithExtraProps[kpiIndex].expendedTopics.includes(topic.topicDisplayName)" class="ignore-wrap-div topic-collapse" @mouseover="mouseover($event, `${tooltipCollapseTopic}`)" @mouseout="mouseout"></div>
                        <div v-else class="ignore-wrap-div topic-collapse" @mouseover="mouseover($event, `${tooltipExpendTopic}`)" @mouseout="mouseout"></div>
                        
                        <div class="ignore-wrap-div" @mouseover="mouseover($event, `${tooltipDeleteTopic}`)" @mouseout="mouseout">  
                          <span class="remove-item el-icon-close" @click="handleRemoveTopicRules($event, kpi, kpiIndex, topicIndex)"></span>
                        </div>
                      </template>
                      <div v-if="topic.rules.length>0" class="rules">
                        <div v-for="(rule, ruleIndex) in topic.rules" :key="ruleIndex">
                          <span v-if="ruleIndex>0" class="rule-or-display">or</span>
                          <wy-kpi-date-range :lastDateNumber="rule.lastDateNumber" :controller="module" :topic="topic" :rule="rule" :ruleIndex="ruleIndex"></wy-kpi-date-range>
                          <div class="ignore-wrap-div" @mouseover="mouseover($event, `${tooltipDeleteRuleset}`)" @mouseout="mouseout">  
                            <span class="remove-item el-icon-close" @click="handleRemoveRule(topic, ruleIndex)"></span>
                          </div>
                        </div>
                      </div>
                      <div v-if="showAddNewRule(topic)" class="kpi-add-new-rule">
                        <div class="ignore-wrap-div" @mouseover="mouseover($event, `${tooltipAddNewRule}`, null, 25)" @mouseout="mouseout">
                          <span class="span-plus">+</span>
                          <el-button v-if="topic.rules.length==0" class="new-rule-button" size="small" @click="handleAddNewRule(topic)"> Add a new rule </el-button>
                          <el-button v-else class="new-rule-button" size="small" @click="handleAddNewRule(topic)"> Add another rule </el-button>
                        </div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div> -->
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <!-- Delete all topics in kpi popup -->
    <wy-dialog 
      ref="deleteAlRulesOverallDialog"
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Delete"
      :hasRememberOption="true"
      :rememberKey="'noShowNextTimeAlertsOverallKpi'"
      :controller="module">
    </wy-dialog>
    <!-- Delete all rules in one topic popup -->
    <!-- <wy-dialog 
      ref="deleteRulesInOneTopicDialog"
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Delete"
      :hasRememberOption="true"
      :rememberKey="'noShowNextTimeAlertTopicRules'"
      :controller="module">
    </wy-dialog> -->
     <!-- Delete all rules in all kpis popup -->
    <wy-dialog 
      ref="deleteAllRulesInAllKPIsOverallDialog"
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Delete"
      :hasRememberOption="true"
      :rememberKey="'noShowNextTimeAlertOverallRemoveAllRules'"
      :controller="module">
    </wy-dialog>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex';
  import WyDialog from '../../widgets/wy-dialog.vue'
  import WyKpiDateRange from '../../widgets/wy-kpi-date-range';
  // import WyKpiContactReasons from './wy-analytics-configuration-kpis-contact-reasons';
  import wyPageSectionTooltip from '../../widgets/wy-page-section-tooltip.vue'
  const hash = require('object-hash');

  export default {
    name: 'wy-configuration-alert-overall-kpis',
    components: {
      'wy-dialog': WyDialog,
      'wy-kpi-date-range': WyKpiDateRange,
      // 'wy-kpi-contact-reasons': WyKpiContactReasons,
      'wy-page-section-tooltip': wyPageSectionTooltip
    },
    props: ['controller'],

    watch: {
      selectedContactReasons: {
        handler: function(newValue) {
          setTimeout(()=>{
            this.selectedContactReasonsModel = newValue
          },200)
        },
        deep: true
      }
    },
    
    data() {
      return {
        module: this,
        loading: false,
        searchKeyword: '',
        searchKeywordInput: '',
        showSearchSection: true,
        contactReasonsData: {},
        activeNames: [],
        localKPIData: [],
        localKPIDataClone: [],

        tooltipConversationTopicsAlerts: 'You can set up alerts for the bot metrics listed below. To define the conditions for triggering an alert, you can select multiple rules. When multiple rules are configured for a bot metric and more than one condition is met, the alert engine goes by the order of rules setup to trigger an alert, i.e., it picks up the first condition met from the list of rules. <br> <br> If a rule is based on a relative or absolute change in the metric value, data from the previous day will be compared to the selected comparison period.  <br> <br> If the rule is configured to trigger an alert when the metric value exceeds or falls below a specified threshold, data from the previous day will be compared to the threshold value.',
        tooltipCollapseKPI: 'Collapse metric',
        tooltipExpendKPI: 'Expand metric',
        tooltipCollapseTopic: 'Collapse topic',
        tooltipExpendTopic: 'Expand Topic',
        tooltipAddTopics: 'Add topic',
        tooltipDeleteTopic: 'Delete topic',
        tooltipDeleteRuleset: 'Delete ruleset',
        tooltipAddNewRule: 'Add rule for metric',
        tooltipsAddAnotherRule: 'Add new rule to metric',
        // overallKpis: ['bes', 'bas', 'vaVolume', 'vaContainedVolume', 'totalMessages', 'containedConversationsTrueResolvedVolume', 'negativeFeedbackScore', 'understandingPercent'],
        metricsLabelMap: {},

        mouseoverHandler: null,

        contactReasonKeywords: '',
        selectedContactReasons: [],
        selectedContactReasonsModel: [],
        topicFilterLoading: false,
        contactReasonsList: [],

        noShowNextTimeAlertsOverallKpi: false,
        noShowNextTimeAlertTopicRules: false,
        noShowNextTimeAlertOverallRemoveAllRules: false,

        activeTopics: [0],
        maxRulesNumber: 6,

        hasError: false
      };
    },

    computed: {
      ...mapGetters(['dataModel', 'isRoleAllow', 'companyConfig', 'companyProfileSettings']),

      filteredContactReasons() {
        return this.getFilteredContactReasons();
      },

      isDisabled() {
        return this.validationKpi();
      },

      hasDataChanged() {
        this.errorValidation();
        return JSON.stringify(this.localKPIDataClone) != JSON.stringify(this.localKPIData) 
      },

      hasNoRules() {
        let hasNoRules = true;
        this.localKPIData.forEach(kpi => {
          hasNoRules = hasNoRules && !this.hasAlert(kpi);
        })
        return hasNoRules;
      }
    },

    methods: {
      ...mapActions(['fetchContactReasonsForTargets', 'fetchCompanyAlertSettings', 'updateCompanyAlertSettings']),

      handleActiveNameChange(e, index) {
        e.stopPropagation();
        this.localKPIData.forEach((kpi, kpiIndex) =>{
          if(kpiIndex == index) {
            const indexItem = this.activeNames.indexOf(kpi.metric);
            if (indexItem > -1) { 
              this.activeNames.splice(indexItem, 1);
            }
            else {
              this.activeNames.push(kpi.metric)
            }
          }
        })
      },

      checkRuleDuplicate() {
        let tempKPIData =  JSON.parse(JSON.stringify(this.localKPIData))
        tempKPIData.forEach(kpi => {
          kpi.items[0].rules.forEach((ruleSource, ruleSourceIndex) => {
            this.$refs[kpi.metric+'rule'+ruleSourceIndex][0].isEmpty = (ruleSource.value === '');
            kpi.items[0].rules.forEach((ruleDes, ruleDesIndex) => {
              this.$refs[kpi.metric+'rule'+ruleDesIndex][0].ruleDuplicate = ruleDes.hasError;
              this.$refs[kpi.metric+'rule'+ruleSourceIndex][0].ruleDuplicate = ruleSource.hasError;
              this.$refs[kpi.metric+'rule'+ruleDesIndex][0].isValueDuplicate = ruleDes.valueDuplicate;
              this.$refs[kpi.metric+'rule'+ruleSourceIndex][0].isValueDuplicate = ruleSource.valueDuplicate;
              if(ruleSourceIndex != ruleDesIndex && !ruleSource.hasError) {
                if(ruleSource.operator == ruleDes.operator) {
                  ruleSource.hasError = true;
                  ruleDes.hasError = true;
                  this.$refs[kpi.metric+'rule'+ruleSourceIndex][0].ruleDuplicate = true;
                  this.$refs[kpi.metric+'rule'+ruleDesIndex][0].ruleDuplicate = true;
                }
              }
            });
          })
        })
      },

      handleKpiHeaderClick(event) {
        event.preventDefault();
        event.stopPropagation();
      },

      deleteClearAllAlertsOverallConfirmButtonCallback() {
        if(this.noShowNextTimeAlertOverallRemoveAllRules) {
          localStorage.setItem('noShowNextTimeAlertOverallRemoveAllRules', true);
        }
        else {
          localStorage.setItem('noShowNextTimeAlertOverallRemoveAllRules', false);
        }
        this.localKPIData.forEach((kpi) => {
          if(kpi.items.length > 0) {
            kpi.items[0].rules = [];
          }
        })
      },

      handleClearAllAlerts(hasNoRules) {
        if(!hasNoRules) {
          if(!localStorage.getItem('noShowNextTimeAlertOverallRemoveAllRules') || localStorage.getItem('noShowNextTimeAlertOverallRemoveAllRules') == 'false') {
            this.noShowNextTimeAlertOverallRemoveAllRules = false;
          }
          else {
            this.noShowNextTimeAlertOverallRemoveAllRules = true;
          }
          if(!this.noShowNextTimeAlertOverallRemoveAllRules) {
            this.$refs.deleteAllRulesInAllKPIsOverallDialog.title = `Clear all Bot Metric Alerts?`;
            this.$refs.deleteAllRulesInAllKPIsOverallDialog.content="If you have alerts configured for bot metrics, they will be permanently deleted. This action cannot be undone. " 
            this.$refs.deleteAllRulesInAllKPIsOverallDialog.open();
            this.$refs.deleteAllRulesInAllKPIsOverallDialog.confirmButtonCallback = async () => {
              this.deleteClearAllAlertsOverallConfirmButtonCallback() 
            }
          }
          else {
            this.deleteClearAllAlertsOverallConfirmButtonCallback();
          }
        }
      },

      hasAlert(kpi) {
        let hasAlerts = false;
        if(kpi.items.length == 1) {
          kpi.items.forEach((item, index) => {
            if(index == 0 && item.rules.length > 0) {
              hasAlerts = true;
            }
          })
        }
        return hasAlerts;
      }, 

      errorValidation() {
        setTimeout(()=>{
          if(document.querySelectorAll('.error-red').length > 0) {
            this.hasError = true;
            this.controller.hasError = true;
          }
          else {
            this.hasError = false
            this.controller.hasError = false;
          }
          if(JSON.stringify(this.localKPIDataClone) != JSON.stringify(this.localKPIData)) {
            this.controller.hasNoSavedChanges = true;
          }
        }, 200)
      },

      getKPILabel(key) {
        return this.metricsLabelMap[key] ? this.metricsLabelMap[key] : key;
      },

      handleDropdownMenu(e) {
        e.stopPropagation();
      },

      deleteAllRulesOverallConfirmButtonCallback(kpi) {
        if(this.noShowNextTimeAlertsOverallKpi) {
          localStorage.setItem('noShowNextTimeAlertsOverallKpi', true);
        }
        else {
          localStorage.setItem('noShowNextTimeAlertsOverallKpi', false);
        }
        kpi.items[0].rules = [];
      },

      handleCommand(command) {
        if(command && command.name == 'delete') {
          this.handleRemoveAllRulesOverall(command.kpi);
        }
      },

      handleRemoveAllRulesOverall(kpi) {
        if(!localStorage.getItem('noShowNextTimeAlertsOverallKpi') || localStorage.getItem('noShowNextTimeAlertsOverallKpi') == 'false') {
          this.noShowNextTimeAlertsOverallKpi = false;
        }
        else {
          this.noShowNextTimeAlertsOverallKpi = true;
        }
        if(!this.noShowNextTimeAlertsOverallKpi) {
          this.$refs.deleteAlRulesOverallDialog.title = `Delete alerts for "${this.getKPILabel(kpi.metric)}" ?`;
          this.$refs.deleteAlRulesOverallDialog.content="If you have alerts configured for this metric, they will be permanently deleted. This action cannot be undone. " 
          this.$refs.deleteAlRulesOverallDialog.open();
          this.$refs.deleteAlRulesOverallDialog.confirmButtonCallback = async () => {
            this.deleteAllRulesOverallConfirmButtonCallback(kpi) 
          }
        }
        else {
          this.deleteAllRulesOverallConfirmButtonCallback(kpi);
        }
      },

      handleAddNewRule(topic) {
        this.mouseout();
        let newRule = {
          lastDateNumber: 0,
          operator: '',
          value: ''
        }
        topic.rules.push(newRule)
      },

      handleRemoveRule(topic, ruleIndex) {
        this.mouseout();
        topic.rules.splice(ruleIndex, 1);
        this.checkRuleDuplicate();
      },

      showAddNewRule(topic) {
        return topic.rules.length <= this.maxRulesNumber - 1
      },

      convertFormat(data) {
        data.data.forEach((item)=> {
          item.name = item.contactReason
        })
      },

      handleSaveUnchanges(newTab, handleAppModalClose) {
        this.controller.$refs.updateDialog.title = `Review changes`;
        this.controller.$refs.updateDialog.content="If you leave this page, any changes you have made will be lost. Do you want to save the changes you made?" 
        this.controller.$refs.updateDialog.open();
        if(this.controller.hasError) {
          this.controller.$refs.updateDialog.disableSaveBtn = true;
        }
        else {
          this.controller.$refs.updateDialog.disableSaveBtn = false;
        }
        this.controller.$refs.updateDialog.confirmButtonCallback = async () => {
          this.updateKpi()
          this.controller.hasNoSavedChanges = false;
          if(handleAppModalClose) {
            handleAppModalClose();
          }
          else {
            this.controller.handleTabClick({name: newTab})
            this.controller.activeTab = newTab
          }
        }
        this.controller.$refs.updateDialog.discardButtonCallback = async () => {
          this.handleDiscardUnsavedChanges();
          
          if(handleAppModalClose) {
            handleAppModalClose();
          }
          else {
            this.controller.handleTabClick({name: newTab})
            this.controller.activeTab = newTab;
          }
        }
      },

      handleDiscardUnsavedChanges() {
        this.controller.hasNoSavedChanges = false;
        this.controller.hasError = false;
        // this.isEditing = false;
        this.localKPIData = JSON.parse(JSON.stringify(this.localKPIDataClone));
      },

      clearSearch() {

      },

      handleChange (metric) {
        let tooltipsEl = document.querySelector(".site-tooltips");
        let tooltips = '';
        setTimeout(()=>{
          if(this.activeNames.includes(metric)) {
            tooltips = this.tooltipCollapseKPI;
          }
          else {
            tooltips = this.tooltipExpendKPI;
          }
          if(this.mouseoverHandler) {
            this.mouseover(this.mouseoverHandler, tooltips)
          }
        }, 20)
        if(tooltipsEl) {
          tooltipsEl.style.display = 'none';
        }
      },

      showAddTopicBtn(kpi) {
        return kpi && kpi.items.length == 1
      },

      validationKpi() {
        return false
      },

      validateTopicChange(kpiData) {
        kpiData.forEach((kpi, kpiIndex) => {
          kpi.items.forEach((item, itemIdex) => {
            this.localKPIDataClone[kpiIndex].items.forEach((itemClone, itemCloneIndex)=>{
              if(itemIdex == itemCloneIndex) {
                if(itemClone.topicDisplayName == item.topicDisplayName) {
                  if(hash(item.rules) !== hash(itemClone.rules)) {
                    item.isChanged = true;
                  }
                }
              }
            })
          })
        })
      },

      addAccessCode() {
        Object.keys(Vue.WyConstants.ALERT_METRICS).forEach(metric => {
          this.localKPIData.forEach(kpi => {
            if(kpi.metric == metric) {
              kpi.access = Vue.WyConstants.ALERT_METRICS[metric].access
            }
          })
        })
      },

      async updateKpi() {
        this.validateTopicChange(this.localKPIData);
        this.addAccessCode();

        this.loading = true;
        let status = await this.updateCompanyAlertSettings(this.localKPIData);
        // let status = 200;
        if(status == 200) {
          this.loading = false;
          this.localKPIData = this.resetTopicsChange(this.localKPIData)
          this.localKPIDataClone = JSON.parse(JSON.stringify(this.localKPIData));
          this.controller.hasNoSavedChanges = false;
          this.$message({
            showClose: true,
            message: this.$t("configurations.alertUpdateSuccess"),
            customClass: 'configuration-success-kpi-alert-message',
            duration: 5000,
            type: 'success'
          });
        }
        else {
          this.loading = false;
          this.$message({
            showClose: true,
            message: this.$t("configurations.alertUpdateFailed"),
            customClass: 'configuration-failed-kpi-alert-message',
            duration: 5000,
            type: 'error'
          });
        }
      },

      handleChangeVisible(show, selectedTopics, metric) {
        if(!show) {
          if(this.selectedContactReasons.length > 0) {
            this.localKPIData.forEach(data => {
              if(data.metric == metric) {
                selectedTopics.forEach(topic => {
                  topic = {
                    topicDisplayName: topic,
                    type: 'topic',
                    isChanged: true,
                    rules: []
                  }
                  data.items.push(topic)
                })
              }
            })
            // this.showAddTopicBtn = false;
          }
          else {
            // this.showAddTopicBtn = true;
          }
        }
      },

      handleApplyAddTopics(el) {
        el[0].hide();
      },

      async prepareData() {
        this.originCompanySettingData = JSON.parse(JSON.stringify(this.companyProfileSettings));
        if(this.companyProfileSettings && this.companyProfileSettings.targetSettings && this.companyProfileSettings.targetSettings.settings.home) {
          if(this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.contactReasons) {
            this.configrationData = this.companyProfileSettings.targetSettings.settings.home.experienceAutomationSummary.contactReasons;
          }
        }
        // await this.fetchContactReasons({forceRefresh: true, logEvent: true});
      },

      getFilteredContactReasons() {
        let filteredListSelected = this.contactReasonsList ? this.contactReasonsList.filter(item => {
          return this.selectedContactReasonsModel.includes(item.contactReason)
        }) : [];
        let filteredList = this.contactReasonsList ? this.contactReasonsList.filter(item => {
          return !this.selectedContactReasonsModel.includes(item.contactReason) && item.contactReason.toLowerCase().includes(this.contactReasonKeywords.trim().toLowerCase())
        }) : [];
        return filteredListSelected.concat(filteredList);
        // return this.contactReasonsList ? this.contactReasonsList.sort((a) => (this.selectedContactReasonsModel.includes(a.contactReason)) ? -1 : 1) : []
      },

      async fetchContactReasons(options) {
        if((!this.loading && this.dataModel.dateEnd) || this.dataModel.dateEnd) {
        // this.loading = true;
        let data = await this.fetchContactReasonsForTargets(options);      
          if(data && data.data) {
            this.contactReasonsList = data.data
          }
        }
      },

      resetTopicsChange(kpisData) {
        let allKpis = this.controller.topicKpis.concat(this.controller.overallKpis);
        let temList = [];
        allKpis.forEach(overallKpi => {
          let hasKPIinData = false;
          kpisData.forEach(kpi => {
            if(overallKpi == kpi.metric) {
              kpi.items.forEach(item => {
                item.isChanged = false;
              })
              temList.push(kpi);
              hasKPIinData = true;
            }
          })
          if(!hasKPIinData) {
            let initKPIsData = this.initKPIsData();
            initKPIsData.forEach(kpi => {
              if(kpi.metric == overallKpi) {
                temList.push(kpi);
              }
            })
          }
        })
        return temList
      },

      async fetchAlertData() {
        let kpisData = [];
        let data = await this.fetchCompanyAlertSettings()
        if(data && data.alertSettings && data.alertSettings.settings) {
          kpisData = data.alertSettings.settings;
          kpisData = this.resetTopicsChange(kpisData);
        }
        else {
          kpisData = this.initKPIsData();
        }

        this.localKPIDataClone = JSON.parse(JSON.stringify(kpisData));
        this.localKPIData = kpisData;
        this.localKPIDataWithExtraProps = JSON.parse(JSON.stringify(kpisData));

        this.localKPIDataWithExtraProps.forEach(kpi => {
          kpi.selectedContactReasons = []
          kpi.expendedTopics = [];
          kpi.items.forEach(item => {
            kpi.selectedContactReasons.push(item.topicDisplayName)
          })
        })
      },

      initKPIsData() {
        if(this.isRoleAllow(4200)) {
          return [
            {
              metric: 'volume',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: [],
                }
              ]
            },
            {
              metric: 'avgBes',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'avgAes',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'avgBas',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'containment',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'bes',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'bas',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'vaVolume',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: [],
                }
              ]
            },
            {
              metric: 'vaContainedVolume',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'totalMessages',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'containedConversationsTrueResolvedVolume',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'negativeFeedbackScore',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'understandingPercent',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            }
          ]
        }
        else {
            return [
            {
              metric: 'volume',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: [],
                }
              ]
            },
            {
              metric: 'containment',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'vaVolume',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: [],
                }
              ]
            },
            {
              metric: 'vaContainedVolume',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'totalMessages',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'containedConversationsTrueResolvedVolume',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'negativeFeedbackScore',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            },
            {
              metric: 'understandingPercent',
              items: [
                {
                  topicDisplayName: 'Overall',
                  type: 'overall',
                  isChanged: false,
                  rules: []
                }
              ]
            }
          ]
        }
      },

      mouseover(e, tooltips, type, scaleX) {
        e.stopPropagation();
        // let ignoreClassName = e.target.className != 'assigned-intent' && e.target.className != 'el-select-dropdown__item' && e.target.className != 'el-select-dropdown__item hover' 
        // && e.target.className != 'ignore-wrap-div' && e.target.className != 'existing-intent-popover-item' && e.target.className != 'el-select__caret el-input__icon el-icon-arrow-up' 
        // && e.target.className != 'el-select el-select--mini'
        if(tooltips && tooltips.trim() != '') {
          this.mouseoverHandler = e;
          let tooltipsEl = document.querySelector(".site-tooltips");
          if(tooltipsEl) {
            tooltipsEl.innerHTML = tooltips
            tooltipsEl.style.display = 'block';
            tooltipsEl.style.left = `${e.target.getBoundingClientRect().x + 10}px`;
            if(!scaleX) {
              scaleX = 10
            }
            if(type == "right") {
              tooltipsEl.style.right = "10px";
              tooltipsEl.style.left = "unset";
            }
            if(type == "left") {
              tooltipsEl.style.left = "10px";
              tooltipsEl.style.right = "unset";
            }
            if(!type || type == "normal") {
              tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - tooltipsEl.getBoundingClientRect().width/2 + scaleX}px`;
            }
            tooltipsEl.style.top = `${e.target.getBoundingClientRect().top + e.target.getBoundingClientRect().height + 5}px`;
          }
        }
        else {
          e.preventDefault();
        }
      },
      mouseout(e) {
        if(e) {
          e.stopPropagation();
        }
        this.mouseoverHandler = null;
        let tooltipsEl = document.querySelector(".site-tooltips");
        if(tooltipsEl) {
          tooltipsEl.style.display = 'none';
        }
      },
    },
    created() {
      let originMap = Vue.WyConstants.ALERT_METRICS;
      if(originMap && Object.keys(originMap).length > 0) {
        Object.keys(originMap).forEach(key => {
          this.metricsLabelMap[key] = originMap[key].label
        })
      }
      this.fetchAlertData()
      //this.fetchContactReasons() // 1055155: disable it which is no longer in used 
    }
  };
</script>

<style lang="scss">
  .wy-configuration-alert-overall-kpis {
    width: 100%;
    height: 100%;
    min-width: 973px;
    .div-title-section {
      width: 100%;
      display: inline-flex;

      .div-title {
        color: var(--site-font-secondary-color);
        font-size: 16px;
        font-weight: 500;
        display: inline-block;
        line-height: 2;
      }
      .question-mark {
        display: inline-block;
        width: 20px;
        padding-top: 3px;
        margin-left: 0px;

        .el-question-mark {
          cursor: pointer;
          color: #214586;
          height: 30px;
          border-radius: 1px;
          border: 0px;
          padding: 2px 5px 8px 5px;
          background-color: transparent;
        }

        .el-question-mark:hover {
          color: #214586;
        }

        .el-button:focus,
        .el-button:hover {
          background-color: transparent;
        }
      }
      .update-btns {
        display: inline-block;
        margin-left: auto;

        .update-save-btn {
          width: fit-content;
          height: fit-content;
          padding: 8px 16px 8px 16px;
          font-size: 15px;
          cursor: pointer;
          background: var(--site-button-primary-btn-background-primary-color);
          color: var(--site-button-primary-btn-text-primary-color) !important;
          border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
          font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
          border-radius: 5px;
          // margin-right: 15px;
          align-items: center;
          justify-content: center;
        }
        .update-save-btn:hover {
          border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
          background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
          border-radius: 5px;
          color: var(--site-button-primary-btn-text-primary-color) !important;
        }
        .update-save-btn:active {
          background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
        }
        .update-save-btn:focus {
          border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
          border-radius: 5px;
          color: var(--site-button-primary-btn-text-primary-color) !important;
        }
        .update-save-btn.disabled {
          background: var(--site-button-primary-btn-disabled-background-primary-color);
          cursor: not-allowed;
        }
        .update-save-btn.disabled:hover {
          border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
          background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
          border-radius: 5px;
          color: var(--site-button-primary-btn-text-primary-color) !important;
        }
        .update-save-btn.disabled:active {
          background: var(--site-button-primary-btn-disabled-background-primary-color) !important;
        }
        .update-save-btn.disabled:focus {
          border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
          border-radius: 5px;
          color: var(--site-button-primary-btn-text-primary-color) !important;
        }
      }
    }
    .div-info {
      display: inline-flex;
      color: #4B5158;
      font-size: 14px;
      font-weight: 400;
      padding: 15px 0px 20px 0px;
      width: calc(100% - 200px);
      max-width: 1025px;
    }
    .clear-all-alerts {
      float: right;
      position: relative;
      top: 35px;
      color: #1A55AD;
      font-size: 12px;
      font-weight: 400;
      left: -3px;
      cursor: pointer;
    }
    .clear-all-alerts.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

  .content-section {
    padding-left: 15px;
    // padding-right: 15px;
    padding-right: 0px;
    // overflow-y: auto;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100% - 107px);
    .el-collapse {
      border-top: 0px;
      border-bottom: 0px;
    }
    .show-top {
      border-top: 2px solid #EBEEF5;
    }
    .el-collapse.kpi-collapse {
      border-bottom: 2px solid #EBEEF5;
      
      .kpi-collapse-header .ignore-wrap-div {
        position: relative;
        left: 10px;
        top: 13px;
        height: 20px;
        width: 20px;
        z-index: 1000;
        .kpi-dropdown-icon {
          height: 20px;
          width: 20px;
          background-color: transparent;
        }
      }
    }
    .el-collapse.kpi-collapse {
      .el-collapse-item__arrow.el-icon-arrow-right {
        margin-left: 0px;
        left: -10px;
        position: relative;
      }
      .el-collapse-item__arrow.is-active {
        transform: rotate(270deg);
      }
      .el-collapse-item__arrow {
        transform: rotate(90deg);
        font-size: 18px;
        font-weight: 600;
      }
      .el-collapse-item__header {
        position: relative;
        padding: 10px 0px;
        .kpi-collapse-header {
          font-size: 16px;
          font-weight: 500;
          color: var(--site-font-tertiary-color);
          display: inline-flex;

          .kpi-dropdown.el-dropdown {
            left: calc(100% - 26px);
            position: absolute;
            margin-top: 6px;
            display: inline-block;
            height: 20px;
          }
          // .header-icon.el-icon-info {
          //   left: calc(100vw - 400px);
          //   position: absolute;
          //   margin-top: 20px;
          // }
          .horizontal-dots {
            padding: 0px;
            border: 0px;
            background-image: url('../../../assets/icons/horizontal-dots_minor.svg') !important;
            cursor: pointer;
            background-size: 20px;
            background-repeat: no-repeat;
            background-position-y: 0px;
            background-position-x: 0px;
            background-color: transparent;
            border-radius: 16px;
            position: relative;
            height: 20px;
            width: 20px;
          }
          .horizontal-dots.disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
          .kpi-status {
            left: calc(100% - 120px);
            position: absolute;
            margin-top: 0px;
            display: inline-block;
            font-size: 14px;
            font-weight: 400;
          }

          .has-alerts {
            background-image: url('../../../assets/icons/icon_has-alerts.svg') !important;
            height: 16px;
            width: 16px;
            background-size: 15px;
            background-repeat: no-repeat;
            background-position-y: 0px;
            background-position-x: 0px;
            display: inline-block;
            position: relative;
            top: 4px;
            left: -6px;
          }
          .has-no-alerts {
            background-image: url('../../../assets/icons/icon_no-alerts.svg') !important;
            height: 16px;
            width: 16px;
            background-size: 15px;
            background-repeat: no-repeat;
            background-position-y: 0px;
            background-position-x: 0px;
            display: inline-block;
            position: relative;
            top: 4px;
            left: -6px;
          }
        }
      }

      .el-collapse-item__content {
        padding-bottom: 20px;
      }
      .el-collapse-item__wrap {
        .el-collapse-item__content {
          margin-top: 3px;
          margin-bottom: 10px;
          margin-left: 0px;
          border-left: 3px #CAD2DA solid;
          padding-bottom: 0px;

          .kpi-content {
            .rules > div {
              padding-left: 24px;
              padding-bottom: 10px;
              position: relative;
              font-size: 14px;
              font-weight: 400;
              color: #202223;
              span.rule-or-display {
                position: absolute;
                top: 15px;
                left: 2px;
                padding: 0px 10px;
              }
            }
            .kpi-add-new-rule {
              position: relative;
              margin-top: 10px;
              margin-left: 24px;
              .span-plus {
                font-size: 26px;
                position: absolute;
                top: -10px;
                left: 8px;
                color: #1A55AD;
              }
              .new-rule-button {
                border-radius: 4px;
                padding: 9px 16px 8px 12px;
                color: #1A55AD;
                border: 0px #1A55AD solid;
                span {
                  padding-left: 16px;
                }
              }
              .new-rule-button:hover {
                background-color: #FFF !important;
                border: 0px #1A55AD solid;
              }
              .new-rule-button:focus {
                background-color: unset;
              }
            }

            .ignore-wrap-div {
              display: inline-flex;
              position: relative;
              top: 0px;
              left:10px;
            }
              .rules {
                span.remove-item {
                  margin-left: 5px;
                  cursor: pointer;
                  position: relative;
                  top: 20px;
                }
              }
            }
            .rules {
              .ignore-wrap-div {
                display: inline-flex;
                position: relative;
                top: -14px;
                left:10px;
              }
            }
          }
        }
      }
        
      &::-webkit-scrollbar {
        background-color: white !important;
        width: 6px !important;
      }
      &::-webkit-scrollbar-thumb{
        background: #CAD2DA !important;
        border-radius: 50px !important; 
      } 
    }
  }
  .kpi-dropdown-menu {
    .el-dropdown-menu__item {
      color: var(--site-font-drop-down-secondary-color) !important;
      padding: 0px;
      span {
        padding: 0px 20px;
      }
    }
    .el-dropdown-menu__item:not(.is-disabled):hover {
      // background-color: #FFF;
      background-color: #F4F6F8;
      color: var(--site-font-drop-down-secondary-color);
    }
  }
</style>